"use strict";
import { GetCapabilitiesStatus } from "state/walletCapabilities/types";
const isValidWalletCapabilities = (walletCapabilities) => {
  return !!walletCapabilities && typeof walletCapabilities === "object" && "byChain" in walletCapabilities && typeof walletCapabilities.byChain === "object" && "getCapabilitiesStatus" in walletCapabilities && typeof walletCapabilities.getCapabilitiesStatus === "string";
};
export const migration24 = (state) => {
  if (!state) {
    return void 0;
  }
  if (!isValidWalletCapabilities(state.walletCapabilities)) {
    return {
      ...state,
      walletCapabilities: {
        getCapabilitiesStatus: GetCapabilitiesStatus.Unknown,
        byChain: {}
      },
      _persist: {
        ...state._persist,
        version: 24
      }
    };
  }
  return {
    ...state,
    _persist: {
      ...state._persist,
      version: 24
    }
  };
};
